import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import Entypo from '@expo/vector-icons/Entypo';

import Colors from '../../constants/Colors';

function PlusMinus(props) {
  const { onChange, min, max, testID } = props;
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (props.value && props.value !== '') {
      const startValue = parseInt(props.value, 10);
      if (startValue >= min && startValue <= max) setValue(startValue);
    }
  }, []);

  const minusOne = () => {
    const newValue = parseInt(value, 10) - 1;
    if (newValue >= min) {
      setValue(newValue);
      onChange(newValue);
    }
  };

  const plusOne = () => {
    const newValue = parseInt(value, 10) + 1;
    if (newValue <= max) {
      setValue(newValue);
      onChange(newValue);
    }
  };

  const plusColor = value == max ? Colors.lightGray : Colors.black;
  const minusColor = value == min ? Colors.lightGray : Colors.black;

  return (
    <View style={styles.view} testID={testID}>
      <TouchableOpacity style={styles.button} onPress={minusOne} testID={`${testID}-minus`}>
        <Entypo name="minus" size={24} color={minusColor} />
      </TouchableOpacity>
      <Text testID={`${testID}-value`}>{value}</Text>
      <TouchableOpacity style={styles.button} onPress={plusOne} testID={`${testID}-plus`}>
        <Entypo name="plus" size={24} color={plusColor} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  view: {
    width: 120,
    height: 40,
    borderWidth: 1,
    borderRadius: 4,
    borderColor: Colors.inputGrayBorder,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    width: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

PlusMinus.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  testID: PropTypes.string,
};

export default PlusMinus;
